import { type GQL } from "@binale-tech/shared";
import { useQuery } from "@apollo/client/react";
import { taxPrepaymentsQuery } from "@domain/context/queries/taxPrepaymentQueries.graphql";

// SP2 (FIBU-22). Vorauszahlungsbescheid amounts for the active company - a small,
// company-scoped reference table (design spec §II.6/§II.7), read with a plain Apollo
// hook (not a context provider, unlike SP1's CalendarEventsProvider: no window/refetch
// lifecycle needed, the row count per company is tiny).
export const useTaxPrepayments = (companyId: string | undefined): GQL.ITaxPrepayment[] => {
    const { data } = useQuery(taxPrepaymentsQuery, {
        variables: { companyId: companyId! },
        skip: !companyId,
        // The app runs Apollo with `no-cache` everywhere (see src/domain/graphql/index.tsx) -
        // InMemoryCache stays inert on purpose, so `cache-first` here would be the only place
        // in src/ actually reading from it, silently serving a stale row after another tab/user
        // edits a Vorauszahlungsbescheid.
        fetchPolicy: "no-cache",
    });
    return data?.taxPrepayments ?? [];
};
